import React from 'react';
import { connect } from 'react-redux';
import { resetGroupForm } from '../../../../actions/group';

@connect()
export default class RightPanelView extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount = () => {
    this.resetForm();
  };

  resetForm = () => {
    this.props.dispatch(resetGroupForm());
  };

  closeModal = () => {
    window.$('.view-group.modal').modal('hide');
    setTimeout(() => {
      this.resetForm();
    }, 500); //timeout waiting for the hide effect to finish
  };

  render() {
    return (
      <div className="ui actions mrbl max-width ">
        <button
          onClick={this.closeModal}
          className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Close}
        </button>
      </div>
    );
  }
}
